// extracted by mini-css-extract-plugin
module.exports = {"heading":"image-heading-link_heading__2Ntun","link":"image-heading-link_link__1L3r3","element":"image-heading-link_element__mJ-KQ","image":"image-heading-link_image__-0WMN"};